import React, { useState, useEffect } from 'react';

export default function BeefBracketTallyVoteLoader({
  winningContender,
  digitCount
}) {
  const [digit1, setDigit1] = useState('0');
  const [digit2, setDigit2] = useState('0');
  const [digit3, setDigit3] = useState('0');
  const [digit4, setDigit4] = useState('0');
  const [digit5, setDigit5] = useState('0');

  // Continuously update the digits from 0 to 9 for a loading effect very fast. Stagging each digit update so they dont all start at 0
  useEffect(() => {
    const interval = setInterval(() => {
      setDigit1((prev) =>
        prev === '9' ? '0' : (parseInt(prev) + 1).toString()
      );
      setTimeout(() => {
        setDigit2((prev) =>
          prev === '9' ? '0' : (parseInt(prev) + 1).toString()
        );
      }, 150);
      setTimeout(() => {
        setDigit3((prev) =>
          prev === '9' ? '0' : (parseInt(prev) + 1).toString()
        );
      }, 300);
      setTimeout(() => {
        setDigit4((prev) =>
          prev === '9' ? '0' : (parseInt(prev) + 1).toString()
        );
      }, 450);
      setTimeout(() => {
        setDigit5((prev) =>
          prev === '9' ? '0' : (parseInt(prev) + 1).toString()
        );
      }, 600);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`vote-count ${digitCount > 3 ? 'small--font' : ''} ${
        winningContender ? 'winning' : ''
      }`}
    >
      <div className="vote-count-digit">
        <span className="digit">{digit1}</span>
      </div>
      {digitCount > 1 && (
        <div className="vote-count-digit">
          <span className="digit">{digit2}</span>
        </div>
      )}
      {digitCount > 2 && (
        <div className="vote-count-digit">
          <span className="digit">{digit3}</span>
        </div>
      )}
      {digitCount > 3 && (
        <div className="vote-count-digit">
          <span className="digit">{digit4}</span>
        </div>
      )}
      {digitCount > 4 && (
        <div className="vote-count-digit">
          <span className="digit">{digit5}</span>
        </div>
      )}
    </div>
  );
}
